export function TranslationFactory(legacy = {}, common = {}) {
    return {
        translation: {
            ...legacy,
            ...common,
        },
    };
}